module.exports = __webpack_public_path__ + "static/img/systerm error@3x.9f8ed97b.png";